import $ from 'jquery'
import { Idiomorph } from 'idiomorph'

// Morphs `element` to match `html` instead of replacing it outright.
// Unlike replaceWithPreserves(), DOM nodes that already exist (matched by id
// or position) are kept in place — never detached and reattached. This
// preserves iframe contents (Stripe Elements, embedded videos), focus,
// selection, and scroll position across re-renders.
//
// Use this for re-rendering forms that contain iframes or other stateful
// embedded content where data-preserve-during-replace would break (since
// detaching an iframe from the DOM destroys its internal state).
export function morphReplace(element, html) {
  const target = element instanceof $ ? element[0] : element
  if (!target) return null

  Idiomorph.morph(target, html, {
    morphStyle: 'outerHTML',
    callbacks: {
      // Honor `data-morph-ignore` on any element: the existing node is kept
      // exactly as-is — children, attributes, and all. Use this for nodes
      // owned by JS at runtime (e.g. a Stripe Element mount point with an
      // injected iframe) that the server has no knowledge of.
      beforeNodeMorphed: (oldNode) => {
        return !oldNode.hasAttribute?.('data-morph-ignore')
      },
      // Honor `data-morph-preserve-attrs="data-foo data-bar"` on any element:
      // those attributes won't be touched on the existing node. Use this for
      // state that JS sets at runtime (e.g. Stripe publishable key on the
      // submit button) which the server doesn't know about and would
      // otherwise be wiped out by the morph.
      beforeAttributeUpdated: (attributeName, element, _mutationType) => {
        const preserve = element.getAttribute?.('data-morph-preserve-attrs')
        if (!preserve) return true
        return !preserve.split(/\s+/).includes(attributeName)
      },
    },
  })

  const newElement = document.getElementById(target.id) || target
  $(newElement).changed?.()
  return $(newElement)
}
